import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { FaRegUser, FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { TiPencil } from "react-icons/ti";
import { HOST } from "../../../../config";
import "./ReviewH.css"
import { useTranslation } from 'react-i18next';

const API_URL = HOST;
function ReviewH() {
  const { t, i18n } = useTranslation();
  
      const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchReviews = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(API_URL + `get_reviews.php?page=${currentPage}`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();

        setReviews(result.reviews || []);
        setTotalPages(result.pages || 1);
        setIsLoading(false);
      } catch (e) {
        setError("Failed to load reviews.");
        setIsLoading(false);
      }
    };

    fetchReviews();
  }, [currentPage]);

  const renderStars = (rating) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
          <FaStar
            key={i}
            className={i < rating ? "text-[#CF9242]" : "text-[#D9D9D9]"}/>
        ))}
      </div>
    );
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div data-aos="fade-up" className="review-all  flex flex-wrap justify-around bg-left bg-no-repeat px-6 py-10 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.2)]"
      style={{ backgroundImage: "url('assets/Backgrounds/motif.png')" }}>

      <section className="flex reviews flex-col my-9 items-center gap-10">

        {isLoading && <p>{t("reviewH.chargement")}</p>}
        {error && <p className="text-red-500">{error}</p>}

        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-[#E9EDF0] flex flex-col items-center border-2 border-[#06299A] rounded-2xl px-4 py-4 w-[23rem] ">
            <div className="bg-[#D9D9D9]  w-20 h-20 rounded-full flex justify-center items-center overflow-hidden -mt-14">
              {review.image_url ? (
                <img
                  src={API_URL + review.image_url}
                  alt={review.full_name}
                  className="w-full h-full object-cover"
                  />
              ) : (
                <FaRegUser className="text-3xl text-gray-600" />
              )}
            </div>

            <div className="mt-2">{renderStars(review.rating)}</div>

            <p className="font-bold text-[18px] mt-2">{review.full_name}</p>
            <p className="text-sm text-[#62718E]">Le {review.formatted_date}</p>

            <p className="text-center italic text-[15px] mt-2">
              "{review.review_text.substring(0, 100)}"
            </p>
          </div>
        ))}

        {!isLoading && totalPages > 1 && (
          <div className="flex justify-center items-center arrow mt-6 gap-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="p-2 border rounded-full disabled:opacity-50">
              <FaChevronLeft />
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="p-2 border rounded-full disabled:opacity-50"
            >
              <FaChevronRight />
            </button>
          </div>
        )}
        {reviews.length === 0 && !isLoading && !error && (
          <p>Soyez le premier à laisser un avis !</p>
        )}
      </section>

      <section className="flex flex-col justify-center items-start max-w-md">
        <h1 className="text-[#243155] font1 font-bold text-3xl mb-4 titre">{t("reviewH.title")}</h1>
        <p className="text-xl mb-6 font4 text-justify plf ">
          {t("reviewH.paragraph")}
        </p>
        <div className="flex items-center bg-[#62718E] border-2 px-6 py-2 rounded-full gap-3 cursor-pointer hover:bg-[#52618A] transition">
          <TiPencil className="text-[#F7D48F] text-2xl" />
          <RouterLink to="/Review" className="text-[#F7D48F] font4 plf  tracking-wider no-underline text-lg">
            {t("reviewH.button")}
          </RouterLink>
        </div>
        <img src="/assets/Photo/review.png" alt="review" className="  w-auto h-80 mx-auto mt-6" />
      </section>

    </div>
  );
}

export default ReviewH;